/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const card = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4 6h2m-2 4h8M2 12.583h12a1 1 0 0 0 1-1V4.25a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v7.333a1 1 0 0 0 1 1Z"
    />
  </svg>
)
export default card
